import { Mary } from "@vwpfs/vwpfs-mary-react-comp-lib";
import { ValidationStatus } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/components/core/07-organisms/Form/_Types";
import React from "react";
import { MaxLeaseLoanValidations } from "../../../../../../store/MaxLeaseLoan/Types";

interface ErrorMessagesProps {
    hasAnyError?: boolean;
    hasValidationError?: boolean;
    validations?: MaxLeaseLoanValidations;
    errors?: Record<string, string>;
}

export const ErrorMessages: React.FC<ErrorMessagesProps> = ({
    hasAnyError,
    hasValidationError,
    errors,
    validations }) => {

    if (!hasAnyError) {
        return null;
    }

    return  (
        <Mary.base.Div className="scl-b-row">
            <Mary.atoms.Blockquote
                theme={{
                    paletteState: Mary.theme.ThemePaletteState.DANGER,
                }}
                background
                className="scl-h-foreground--contrast-state-danger"
                style={{ position: "relative" }}
            >
                <h5>
                    <Mary.atoms.Icon
                        style={{
                            fontSize: ".75em",
                            verticalAlign: "middle",
                            marginRight: "5px",
                        }}
                        name={"exclamation-triangle"}
                    />&nbsp;Controleer de ingevulde velden
                </h5>
                <br />
                {(hasValidationError && validations) && (
                    <>
                        <p>Om door te gaan moet u de volgende velden (correct) invullen.</p>
                        <ul style={{ marginBottom: "20px" }}>
                            {Object.values(validations)
                                .filter((validation) => validation?.status === ValidationStatus.ERROR)
                                .map((validation, index) => (
                                    <li key={`validation-error-${index}`}>
                                        <Mary.atoms.Icon
                                            style={{
                                                fontSize: "8px",
                                                verticalAlign: "middle",
                                                marginRight: "5px",
                                                marginLeft: "10px",
                                            }}
                                            name={"circle"}
                                        />
                                        {validation?.title}
                                    </li>
                                ))}
                        </ul>
                    </>
                )}
                {errors && (
                    <>
                        <p>We kunnen geen berekening maken op basis van de ingevoerde waarden.</p>
                        <ul>
                            {Object.values(errors).map((error, index) => (
                                <li key={`result-error-${index}`}>
                                    <Mary.atoms.Icon
                                        style={{
                                            fontSize: "8px",
                                            verticalAlign: "middle",
                                            marginRight: "5px",
                                            marginLeft: "10px",
                                        }}
                                        name={"circle"}
                                    />
                                    {error}
                                </li>
                            ))}
                        </ul>
                    </>
                )}
            </Mary.atoms.Blockquote>
        </Mary.base.Div>
    );
};
